import axios from "axios";
import {appyShopConfig} from "../config";
import {config} from "../config-merchant";

export function getTopHeader(language: string) {
    return axios.get(appyShopConfig.apiUrl + 'utils/' + config.merchantId + '/top-header/' + language)
}
